/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_StateInputs */

const de__field_state = /** @type {(inputs: _Field_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundesland`)
};

/**

* @param {_Field_StateInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_state = /** @type {((inputs?: _Field_StateInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_StateInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_state(inputs)
});